<div class="overlay-warp export-warp">
    <div class="export-title">
        <img src="/assets/images/export/export-report.svg">
        <span translate>data.export.title</span>
    </div>
    <div class="type-selected">
        <span class="title" translate>data.export.type</span>
        <div #types class="select pointer" (click)="isOpenType=true">
            <span *ngIf="selectedType==eReportType.CSV">Csv</span>
            <span *ngIf="selectedType==eReportType.PDF">Pdf</span>
            <img src="/assets/images/export/arrow-down.svg">
        </div>
    </div>
    <div class="content" *ngIf="selectedType==eReportType.PDF">
        <que-selected-users [usersInput]="users" (selectUserEvent)="selectUsers($event)"></que-selected-users>
    </div>
    <div class="footer">
        <div>
            <div class="custom-checkbox" *ngIf="selectedType==eReportType.CSV && isShowComparison">
                <div class="choose pointer" (click)="isComparison = !isComparison"
                    [ngClass]="{'selected':isComparison}">
                    <div class="inner-selected">
                        <img src="/assets/images/auto-fill/vi.svg">
                    </div>
                </div>
                <span translate>data.export.btn.display</span>
            </div>
        </div>
        <div class="btns">
            <button class="cancel pointer" (click)="cancel()" translate>btns.cancel</button>
            <button class="do pointer" [ngClass]="{'diasbled':selectedUsersIdes.length==0 && selectedType!=eReportType.CSV}"
                (click)="selectedUsersIdes.length>0 || selectedType==eReportType.CSV ?download():null" translate>data.export.btn.download</button>
        </div>
    </div>
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="types" [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
    (backdropClick)="isOpenType= false" [cdkConnectedOverlayOpen]="isOpenType"
    [cdkConnectedOverlayPositions]="positonArea">
    <div class="overlay-warp">
        <div class="item" (click)="chooseType(eReportType.CSV)">
            <div class="name">
                <img src="/assets/images/export/download.svg">
                <div class="include">
                    <span>Csv</span>
                    <span *ngIf="isShowComparison" class="include-text" translate>data.export.includeComparison</span>
                </div>
            </div>
            <img *ngIf="selectedType==eReportType.CSV" src="/assets/images/export/selected.svg">
        </div>
        <div class="item" *ngIf="this.users.length>0" (click)="chooseType(eReportType.PDF)">
            <div class="name">
                <img src="/assets/images/export/download.svg">
                <span>Pdf</span>
            </div>
            <img *ngIf="selectedType==eReportType.PDF" src="/assets/images/export/selected.svg">
        </div>
    </div>
</ng-template>